import dayjs from "dayjs";
import type { TriageFlowStatus, TriageResultRow } from "./types";

const OBJECT_TYPES = [
  {
    code: "insight",
    name: "Insight",
    subTypes: [
      { code: "regulation", name: "Regulation" },
      { code: "guidance", name: "Guidance" },
    ],
  },
  {
    code: "rtq",
    name: "RTQ",
    subTypes: [{ code: "", name: "" }],
  },
] as const;

const TITLES = [
  "New Regulation 0311",
  "EMA Guidance Update Q1",
  "FDA Labeling Change Notice",
  "Cardiovascular Risk Communication",
  "MHRA Post-Market Review",
  "RTQ Semaglutide Supply Clarification",
  "Oncology Labeling Amendment",
  "Pediatric Study Requirements",
];

const TRIAGE_RESULTS: ReadonlyArray<{
  label: string;
  isLink: boolean;
}> = [
  { label: "Manual Review", isLink: true },
  { label: "Auto Alert Flow", isLink: true },
  { label: "Escalation Flow", isLink: true },
  { label: "", isLink: false },
];

const FLOW_STATUSES: TriageFlowStatus[] = [
  "notStarted",
  "completed",
  "inProgress",
  "terminate",
  "none",
];

const VERSIONS = ["1.0", "2.0", "3.0", "1.0", "2.0"];

function buildMockRow(index: number): TriageResultRow {
  const objectTypeEntry = OBJECT_TYPES[index % OBJECT_TYPES.length];
  const subTypeEntry =
    objectTypeEntry.subTypes[index % objectTypeEntry.subTypes.length];
  const triageEntry = TRIAGE_RESULTS[index % TRIAGE_RESULTS.length];
  const flowStatus = FLOW_STATUSES[index % FLOW_STATUSES.length];
  const createDate = dayjs("2026-04-01")
    .add(index % 120, "day")
    .startOf("day")
    .toISOString();
  const objectId =
    objectTypeEntry.code === "rtq"
      ? `RTQ${10000 + (index % 900)}`
      : `INS${28000 + (index % 900)}`;

  return {
    resultId: `TRI_${String(4800 + index).padStart(6, "0")}`,
    objectType: objectTypeEntry.code,
    objectTypeName: objectTypeEntry.name,
    objectSubType: subTypeEntry.code,
    objectSubTypeName: subTypeEntry.name,
    objectId,
    title: TITLES[index % TITLES.length],
    version: VERSIONS[index % VERSIONS.length],
    triageResult: triageEntry.label,
    triageResultIsLink: triageEntry.isLink && Boolean(triageEntry.label),
    flowStatus,
    createDate,
  };
}

/** Local mock rows for AI Hub Triage Results (v1). */
export const MOCK_TRIAGE_RESULTS: TriageResultRow[] = Array.from(
  { length: 500 },
  (_, index) => buildMockRow(index),
);
